export default function isTime(string) {
  // https://www.regextester.com/95535
  return /^$|^(([01][0-9])|(2[0-3])):?[0-5][0-9]$/.test(string);
}
